import * as React from 'react';

const BusinessSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={48} height={48} {...props}>
        <g
            id="business_svg__Business"
            stroke="#1D0A32"
            strokeWidth={2}
            fill="none"
            fillRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path
                d="M24 1a3 3 0 012.995 2.824L27 4l-.001 2H45v34h-6.757l1.799 1.799.135.144a3 3 0 01-4.25 4.22h0l-.128-.121L29.757 40H18.404l-6.04 6.042-.128.12a3 3 0 01-4.25-4.219l.135-.144L9.92 40H3V6h17.999L21 4l.005-.176A3 3 0 0124 1zM1 40h46M1 6h46"
                id="business_svg__Rectangle-2"
            />
            <g id="business_svg__preso" transform="translate(9 12)">
                <path
                    id="business_svg__Path"
                    d="M12.08 17v5h-12L0 0h12l.08 11"
                />
                <g id="business_svg__lines" transform="translate(17 4.5)">
                    <path id="business_svg__Path-34-Copy-2" d="M0 12.5h13" />
                    <path id="business_svg__Path-34-Copy" d="M0 6.5h11" />
                    <path id="business_svg__Path-34" d="M0 .5h13" />
                </g>
            </g>
        </g>
    </svg>
);

BusinessSvg.displayName = 'BusinessSvg';
export default BusinessSvg;
